import React from 'react';
import FooterSocialLinks from './FooterSocialLinks.react';
import createClass from 'create-react-class';

const Footer = createClass({
    render() {
        return <div className="Footer">
            <div className="Links">
                <a className="Item Active" href="/download">دریافت اسنپ</a>
                <a className="Item" href="/career">فرصت‌های شغلی</a>
                <a className="Item" href="/terms">شرایط و قوانین</a>
                <a className="Item" href="/policy">حریم خصوصی</a>
                <a className="Item" href="/about">درباره ما</a>
                <a className="Item" href="/contact">تماس با ما</a>
                <a className="Item" href="/faq">سوالات متداول</a>
            </div>

            <div className="Copyright">
                ©کپی رایت تمامی حقوق مادی و معنوی این سرویس (وب سایت و اپلیکیشن های موبایل) متعلق به ایده گزین ارتباطات
                روماک (اسنپ) است.
            </div>

            <FooterSocialLinks/>

            <div className={'Organs'}>
                <img id='rgvjjzpefukzjxlznbqe'
                     style={{cursor: 'pointer'}}
                     onClick={() => {
                         window.open('https://logo.samandehi.ir/Verify.aspx?id=37612&p=xlaojyoegvkarfthuiwk', 'Popup', 'toolbar=no, scrollbars=no, location=no, statusbar=no, menubar=no, resizable=0, width=450, height=630, top=30');
                     }}
                     alt='logo-samandehi'
                     src='https://logo.samandehi.ir/logo.aspx?id=37612&p=qftiyndtwlbqnbpdodrf'/>

                <img src="https://trustseal.enamad.ir/logo.aspx?id=30599&p=vjymgthvfujyzpfvzpfv"
                     alt="نماد اعتماد الکترونیکی" onClick={() => {
                    window.open('https://trustseal.enamad.ir/Verify.aspx?id=30599&p=fuixdrfsyncrjzpgjzpg', 'Popup', 'toolbar=no, location=no, statusbar=no, menubar=no, scrollbars=1, resizable=0, width=580, height=600, top=30');
                }}/>

                <img src="https://ecunion.ir/bundles/pouyasoft/home/img/namad.png"
                     alt="ecunion"
                     style={{cursor: 'pointer',backgroundColor: '#fff', padding: '10px'}}
                onClick={() => {
                window.open('https://ecunion.ir/verify/snapp.ir?token=37368045acf0232aa0c3', 'Popup','toolbar=no, location=no, statusbar=no, menubar=no, scrollbars=1, resizable=0, width=580, height=600, top=30');
                }}/>


            </div>
        </div>;
    }
});

module.exports = Footer;



// WEBPACK FOOTER //
// ./src/js/components/common/Footer.react.js